/**
 * @generated SignedSource<<b2027ad63693f40dac97398a95d5211d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteTicketingCustomFieldDefinitionInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type useDeleteCustomFieldDefinitionMutation$variables = {
  input: DeleteTicketingCustomFieldDefinitionInput;
};
export type useDeleteCustomFieldDefinitionMutation$data = {
  readonly deleteTicketingCustomFieldDefinition: {
    readonly clientMutationId: string | null;
    readonly deletedId: string;
  } | null;
};
export type useDeleteCustomFieldDefinitionMutation = {
  variables: useDeleteCustomFieldDefinitionMutation$variables;
  response: useDeleteCustomFieldDefinitionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTicketingCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "deleteTicketingCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDeleteCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ca15d053349a4b706648b1e7b4556a52",
    "id": null,
    "metadata": {},
    "name": "useDeleteCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation useDeleteCustomFieldDefinitionMutation(\n  $input: DeleteTicketingCustomFieldDefinitionInput!\n) {\n  deleteTicketingCustomFieldDefinition(input: $input) {\n    clientMutationId\n    deletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f23d9bd4b051e85ad5bcbaa1158ec910";

export default node;
